import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlbumCard } from "@/components/AlbumCard";
import ForgeFridayBanner from "@/components/ForgeFridayBanner";
import DailyMessageBanner from "@/components/DailyMessageBanner";
import HomeStatsStrip from "@/components/HomeStatsStrip";
import RecentReleases from "@/components/RecentReleases";
import FollowFeed from "@/components/FollowFeed";
import CinematicHero from "@/components/animated/CinematicHero";
import TrendingStation from "@/components/animated/TrendingStation";
import FeatureCinema from "@/components/animated/FeatureCinema";
import MarqueeBand, { FinalCTA } from "@/components/animated/MarqueeBand";
import { Link } from "react-router-dom";

export default function Home() {
  const [albums, setAlbums] = useState([]);
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    api.get("/albums?limit=12").then((r) => setAlbums(r.data.albums)).catch(() => {});
    api.get("/artists?limit=8").then((r) => setArtists(r.data.artists)).catch(() => {});
  }, []);

  return (
    <div className="pb-32">
      {/* Contextual site-wide banners */}
      <DailyMessageBanner />
      <ForgeFridayBanner />

      {/* Cinematic tilted-phone hero */}
      <CinematicHero />

      {/* Social-proof stat strip (existing component) */}
      <HomeStatsStrip />

      {/* Trending station — every artist, fair rotation, tap any row */}
      <TrendingStation />

      {/* Big display marquee break */}
      <MarqueeBand />

      {/* Recent releases (existing component) */}
      <RecentReleases />

      {/* Feature cinema (alternating rows) */}
      <FeatureCinema />

      {/* Follow feed for signed-in users */}
      <FollowFeed />

      {/* THE VAULT */}
      <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24 border-t border-[#2A2A2A]">
        <div className="mb-8">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4500] mb-2">06 / The Vault</div>
          <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.9]">
            New albums · <span className="text-gray-500">$15</span>
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
          {albums.map((a) => <AlbumCard key={a.id} album={a} />)}
          {albums.length === 0 && (
            <div className="col-span-full text-center font-mono text-xs text-gray-500 uppercase py-16 border border-dashed border-[#2A2A2A]">
              Vault empty. Be the first to press a record.
            </div>
          )}
        </div>
      </section>

      {/* Artists */}
      {artists.length > 0 && (
        <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24 border-t border-[#2A2A2A]">
          <div className="mb-8">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4500] mb-2">07 / Forgemasters</div>
            <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.9]">Artists on the anvil</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {artists.map((a) => (
              <Link
                key={a.id}
                to={`/artist/${a.id}`}
                data-testid={`artist-card-${a.id}`}
                className="group border border-[#2A2A2A] p-4 md:p-6 hover-lift bg-[#121212]"
              >
                <div className="h-16 w-16 bg-[#FF4500]/20 grid place-items-center mb-4 font-display text-2xl text-[#FF4500] group-hover:bg-[#FF4500] group-hover:text-black transition-colors">
                  {(a.display_name || a.username)[0].toUpperCase()}
                </div>
                <div className="font-display font-bold">{a.display_name || a.username}</div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-gray-500 mt-1">@{a.username}</div>
              </Link>
            ))}
          </div>
        </section>
      )}

      {/* Closing CTA */}
      <FinalCTA />
    </div>
  );
}
